export default __webpack_public_path__ + "static/media/publications.22ffbd68.png";